"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fdate = fdate;
const fdatetime_1 = require("./fdatetime");
// domyślnie format yyyy-MM-dd
const dtfunction = fdatetime_1.formatDateFunction['yyyy-MM-dd'];
/**
 * formatuje datę do formatu yyyy-MM-dd
 * @param dt data typu Date
 */
function fdate(dt) {
    if (!isNaN(dt.getTime())) {
        return dtfunction(dt, null);
    }
    return '';
}
//# sourceMappingURL=fdate.js.map